import { useLayoutEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import LandingPage from "./components/pages/LandingPage";

const AppRouter = () => {
  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Switch>
      <Route path="/" component={LandingPage} />
    </Switch>
  );
};

export default AppRouter;
